import { Observable } from 'rxjs';
const storage = new WeakMap();
export function resizeObserver(element) {
    if (storage.has(element)) {
        return storage.get(element);
    }
    const observer = new Observable((subscriber) => {
        const resize = new ResizeObserver((entries) => subscriber.next(entries[0]));
        resize.observe(element);
        return () => {
            resize.unobserve(element);
        };
    });
    storage.set(element, observer);
    return observer;
}
//# sourceMappingURL=rx-resize-observer.js.map